<!-- menu -->
<template>
  <div class="consult_container" :class="[consultContainer]">
    <el-dialog
      title="自助询价"
      :lock-scroll="false"
      :visible.sync="dialogVisible"
      :before-close="handleClose">
       <el-form ref="consultFrom" :model="consultFrom" :rules="rules">
        <div class="consult_form">
          <!-- 个人信息 -->
          <div>
            <div style="display:flex;">
              <span class="line"></span>
              <span :class="[font20, 'font_bold','title']">个人信息</span>
            </div>
            <div class="row1">
              <el-form-item label="姓名" prop="userName" @blur="shwoFooter" @focus="cholseFooter" >
              <div style="display:flex;">
                <el-input class="name" v-model="consultFrom.userName" placeholder="请输入您的姓名" />
                <el-select v-model="consultFrom.sex" placeholder="选择先生or女士">
                  <el-option popper-class="consult-select-cla" v-for="item in sexList" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </div>
              </el-form-item>
              <el-form-item label="手机号码" prop="moblie">
                <el-input class="iphone" type="number" @blur="shwoFooter" @focus="cholseFooter" oninput="if(value.length>11)value=value.slice(0,11)" v-model="consultFrom.moblie" placeholder="请输入您的手机号码" />
              </el-form-item>
            </div>
          </div>
          <!-- 需求说明 -->
          <div style="margin-top:24px;">
            <div style="display:flex;">
              <span class="line"></span>
              <span :class="[font20, 'font_bold','title']">需求说明</span>
            </div>
            <div class="row2">
              <el-form-item label="产品/样品名称" prop="sampleName">
                <el-input type="text" v-model="consultFrom.sampleName" @blur="shwoFooter" @focus="cholseFooter" placeholder="请输入产品/样品名称，100字以内" maxlength="100" />
              </el-form-item>
            </div>
            <div class="row3">
              <el-form-item label="需求描述" prop="content">
                <el-input type="textarea" :rows="2" v-model="consultFrom.content"  @blur="shwoFooter" @focus="cholseFooter" placeholder="请输入需求描述，200字以内" maxlength="200" show-word-limit />
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
      <span slot="footer">
          <el-button :class="[font16]" type="primary" @click="handleConsult" :loading="!isAdd">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {shwoFooters,
    cholseFooters} from '@/unit/common'
var phoneReg = /^[1][0-9][0-9]{9}$/
export default {
  name: "consult",
  data() {
    return {
      isAdd: true,
      dialogVisible:false,
      sexList:[
        {
          label:'先生',
          value: '1'
        },
        {
          label:'女士',
          value: '2'
        }
      ],
      consultFrom: {
         userName: '',
         sex: '',
         moblie: '',
         sampleName: '',
         content: '',
         sourceName:'',
         sourceLink:''
      },
      phoneReg: '',
      rules:{
        userName: [{
          required: true,
          message: '请输入您的姓名',
          trigger: 'blur'
        }],
        moblie:[
          {
            required: true,
            message: '请输入您的手机号码',
            trigger: 'blur'
          },
          { pattern: phoneReg,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ],
        sampleName:[{
          required: true,
          message: '请输入产品/样品名称',
          trigger: 'blur'
        }]
      }
    }
  },
  computed: {
    consultContainer(){
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "mconsultcontainer";
        case "sm":
          return "mconsultcontainer";
        case "md":
          return "pcconsultcontainer";
        case "lg":
          return "pcconsultcontainer";
        case "xl":
          return "pcconsultcontainer";
      }
    },
    font20() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "m20";
        case "sm":
          return "m20";
        case "md":
          return "p20";
        case "lg":
          return "p20";
        case "xl":
          return "p20";
      }
    },
    font16(){
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "m16";
        case "sm":
          return "m16";
        case "md":
          return "p16";
        case "lg":
          return "p16";
        case "xl":
          return "p16";
      }
    }
  },
  mounted() {
    this.listenerKeyBord()
  },
  methods: {
    listenerKeyBord(){
      if (/Android/gi.test(navigator.userAgent)) {
        const innerHeight = window.innerHeight;
        window.addEventListener('resize', () => {
          const newInnerHeight = window.innerHeight;
          if (innerHeight > newInnerHeight) {
            // 键盘弹出事件处理
            // console.log('键盘弹出事件处理')
            // alert('键盘弹出事件处理')
            cholseFooters()
          } else {
            // 键盘收起事件处理
            // console.log('键盘收起事件处理')
            // alert('键盘收起事件处理')
            shwoFooters()
          }
        });
      } else {
        window.addEventListener('focusin', function(e){
          e.target.className.indexOf('swiper-button-next-inn') > -1 || e.target.className.indexOf('swiper-button-prev-inn') > -1 || cholseFooters()
          // console.log('键盘弹出事件处理')
          // alert('键盘弹出事件处理')
          // 键盘弹出事件处理
        });
        window.addEventListener('focusout', () => {
          // 键盘收起事件处理
          // console.log('键盘收起事件处理')
          shwoFooters()
        });
      }
    },
    handleClose(){
        this.dialogVisible = false
        this.consultFrom.sex = ''
        this.$refs.consultFrom.resetFields()
    },
    handleConsult(){
      this.$refs.consultFrom.validate(valid => {
        if (valid) {
          if (!this.isAdd) {
            return
          }

          this.consultFrom.sourceLink=window.location.href
          //如果路由是详情页或者服务则需要带上名字
          if (this.consultFrom.sourceLink.includes('detectionDetail')||this.consultFrom.sourceLink.includes('services')||this.consultFrom.sourceLink.includes('enterpriseDetail')) {
              this.consultFrom.sourceName =  window.localStorage.getItem("sourceNameForm");
          }else {
            window.localStorage.setItem("sourceNameForm","");
          }
          this.isAdd = false
          this.$api.iotHome
            .consultFrom(this.consultFrom)
            .then((res) => {
                if (res.data.success == true) {
                  this.$message({
                    showClose: false,
                    message: '提交成功！感谢您的咨询，我们的专属销售代表会在24小时内和您联系，请保持电话畅通，谢谢！',
                    type: 'success',
                    duration: '3000'
                  })
                  setTimeout(()=>{
                    this.handleClose()
                    this.isAdd = true
                  },1000)
                }else{
                  this.$message({
                    showClose: false,
                    message: '提交失败',
                    type: 'error',
                    duration: '3000'
                  })
                  this.isAdd = true
                }
            })
        }else{
          return
        }
      })
    },
    shwoFooter(){
      shwoFooters()
    },
    cholseFooter(){
      cholseFooters()
    },
  },
};
</script>

<style lang="scss">
  input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    input[type="number"]{
        -moz-appearance: textfield;
    }
    .el-select-dropdown{
      z-index: 99999991!important;
    }
    .consult_container{
      .el-dialog__wrapper{
        z-index: 9999999!important;
        top:0;
      }
      .el-dialog{
        border-radius: 8px;
      }
      .el-dialog__header{
          padding: 0;
          display: flex;
          align-items: center;
          background: #f5f6f9;
          // border-radius: 8px;
          .el-dialog__title{
            font-family: PingFangSC-Bold;
            font-weight: 600;
            text-align: left;
            color: #1e203c;
            line-height: 1;
          }
      }
      .consult_form{
        .title{
          color: #1e203c;
          line-height: 1;
        }
        .line{
          width: 4px;
          margin-right: 8px;
          background: #122266;
        }
        .el-form-item{
          display: flex;
          flex-direction: column;
          margin-top: 15px;
          margin-bottom: 0;
        }
        .el-form-item__content{
          margin-left: 0!important;
          margin-top: 16px;
        }
        .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
          content:'';
          margin-right: 0px;
        }
        .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label::after{
          content:'*';
          color: #F56C6C;
          margin-left: 4px;
        }
        .row2{
          .el-form-item{
            .el-input__inner{
              width: 100%!important;
              height: 48px!important;
            }
          }
        }
      }
    }
    .pcconsultcontainer{
      .el-dialog{
        width: 1000px!important;
      }
      .el-dialog__header{
        height: 60px;
        padding-left: 40px;
        .el-dialog__title{
          font-size: 24px;
        }
      }
      .el-dialog__headerbtn{
        top: 20px;
        right: 40px;
        font-size: 28px;
        .el-dialog__close{
          color: #1e203c;
          font-weight: bold;
        }
      }
      .consult_form{
        padding: 40px 40px 0 40px;
        .line{
          height: 20px;
        }
        .el-form-item__label{
          text-align: left;
          font-size: 16px;
          color: #1e203c;
          font-family: PingFangSC-Bold;
          height: 16px;
          line-height: 1;
          padding: 0;
        }
        .el-input__inner{
          border: 1px solid #e6e8f0!important;
          font-size: 16px;
        }
        .row1{
          display:flex;
          justify-content: space-between;
          .el-form-item{
            width: calc(50% - 12px)!important;
            .el-input__inner{
              width: 100%!important;
              height: 48px!important;
            }
          }
          .el-form-item:nth-child(1){
            margin-right: 12px;
            .name{
              width: calc(50% - 12px)!important;
              margin-right: 24px;
            }
            .el-select{
              width: calc(50% - 12px)!important;
            }
          }
          .el-form-item:nth-child(2){
            margin-left: 12px;
          }
        }
        .row2{
          .el-form-item{
            .el-input__inner{
              width: 100%!important;
              height: 48px!important;
            }
          }
        }
      }
      .el-dialog__footer{
        padding: 40px;
        text-align: center;
        .el-button{
          width: 100%;
          height: 44px;
          background: #122266;
          border-radius: 4px;
          font-weight: 500;
          color: #ffffff;
        }
      }
    }
    .mconsultcontainer{
      .el-dialog{
        width: calc( 100% - 24px)!important;
        margin-top: 71px!important;
      }
      .el-dialog__header{
        height: 40px;
        padding-left: 15px;
        .el-dialog__title{
          font-size: 16px;
        }
      }
      .el-dialog__headerbtn{
        top: 6px;
        right: 15px;
        font-size: 20px;
        .el-dialog__close{
          color: #1e203c;
          font-weight: bold;
        }
      }
      .consult_form{
        padding: 15px 15px 0 15px;
        .line{
          height: 15px;
        }
        .el-form-item__label{
          text-align: left;
          font-size: 14px;
          color: #1e203c;
          font-family: PingFangSC-Bold;
          height: 14px;
          line-height: 1;
          padding: 0;
        }
        .el-input__inner{
          border: 1px solid #e6e8f0!important;
          font-size: 14px;
        }
        .el-form-item__error{
          padding-top: 1px;
        }
        .row1{
          .el-form-item{
            width: 100%!important;
            .el-input__inner{
              width: 100%!important;
              height: 30px!important;
              line-height: 30px!important;
            }
          }
          .el-form-item:nth-child(1){
            .name{
              width: calc(50% - 6px)!important;
              margin-right: 12px;
            }
            .el-select{
              width: calc(50% - 6px)!important;
            }
          }
        }
        .row2{
          .el-form-item{
            .el-input__inner{
              width: 100%!important;
              height: 30px!important;
              line-height: 30px!important;
            }
          }
        }
      }
      .el-dialog__footer{
        padding: 20px 15px;
        text-align: center;
        .el-button{
          width: 100%;
          height: 35px;
          background: #122266;
          border-radius: 4px;
          font-weight: 500;
          color: #ffffff;
        }
      }
    }
    .el-message {
      z-index: 1000000!important;
      color: #fff!important;
      top: 50%!important;
      width: 55px!important;
      min-width: 320px!important;
      .el-message__content{
        line-height: 24px;
      }
    }
    .el-message__closeBtn:hover{
      color: #fff!important;
    }

</style>
